// extracted by mini-css-extract-plugin
export default {"error":"GenericError_error__4InCa","center":"GenericError_center__2nQpL"};